import { createApp } from 'vue'
import App from './App.vue'
import './assets/fonts/KORUNISH.TTF'
createApp(App).mount('#app')
